"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _filterDOMProps = _interopRequireDefault(require("../../utils/filterDOMProps"));

var _Heading = _interopRequireDefault(require("../../Heading"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

if (process.env.SCALE_MEDIUM && process.env.SCALE_LARGE) {
  require("../../spectrum-css/illustratedmessage/index.css");

  require("../../spectrum-css/illustratedmessage/index-diff.css");
} else if (process.env.SCALE_LARGE) {
  require("../../spectrum-css/illustratedmessage/index-lg.css");
} else {
  require("../../spectrum-css/illustratedmessage/index.css");
}

if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHT) require("../../spectrum-css/illustratedmessage/multiStops/light.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARK) require("../../spectrum-css/illustratedmessage/multiStops/dark.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHTEST) require("../../spectrum-css/illustratedmessage/multiStops/lightest.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARKEST) require("../../spectrum-css/illustratedmessage/multiStops/darkest.css");

/**
 * An IllustratedMessage displays an illustration icon and a message, usually in an empty state or on an error page.
 */
var IllustratedMessage =
/*#__PURE__*/
function (_React$Component) {
  _inherits(IllustratedMessage, _React$Component);

  function IllustratedMessage() {
    _classCallCheck(this, IllustratedMessage);

    return _possibleConstructorReturn(this, _getPrototypeOf(IllustratedMessage).apply(this, arguments));
  }

  _createClass(IllustratedMessage, [{
    key: "isIllustrationDecorative",
    value: function isIllustrationDecorative() {
      var _this$props = this.props,
          illustration = _this$props.illustration,
          heading = _this$props.heading,
          description = _this$props.description;

      if (illustration) {
        var props = illustration.props;
        var ariaLabel = props['aria-label'],
            ariaLabelledby = props['aria-labelledby'],
            ariaHidden = props['aria-hidden']; // If illustration is explicitly hidden for accessibility return the ariaHidden value.

        if (ariaHidden != null) {
          return ariaHidden;
        } // If illustration is explicitly labelled using aria-label or aria-labelledby return null.


        if (ariaLabel || ariaLabelledby) {
          return false;
        }
      } // Otherwise, assume the image is decorative.


      return !!(heading || description);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          _this$props2$illustra = _this$props2.illustration,
          illustration = _this$props2$illustra === void 0 ? null : _this$props2$illustra,
          className = _this$props2.className,
          heading = _this$props2.heading,
          description = _this$props2.description,
          ariaLevel = _this$props2.ariaLevel,
          otherProps = _objectWithoutProperties(_this$props2, ["illustration", "className", "heading", "description", "ariaLevel"]);

      if (illustration && (!illustration.props.className || !illustration.props.className.includes('spectrum-IllustratedMessage-illustration'))) {
        illustration = _react["default"].cloneElement(illustration, {
          className: (0, _classnames["default"])(illustration.props.className, 'spectrum-IllustratedMessage-illustration'),
          'aria-hidden': this.isIllustrationDecorative() || null
        });
      }

      return _react["default"].createElement("div", _extends({}, (0, _filterDOMProps["default"])(otherProps), {
        className: (0, _classnames["default"])('spectrum-IllustratedMessage', className)
      }), illustration, heading && _react["default"].createElement(_Heading["default"], {
        variant: "pageTitle",
        className: "spectrum-IllustratedMessage-heading",
        "aria-level": ariaLevel
      }, heading), description && _react["default"].createElement("p", {
        className: "spectrum-Body--secondary spectrum-IllustratedMessage-description"
      }, description));
    }
  }]);

  return IllustratedMessage;
}(_react["default"].Component);

exports["default"] = IllustratedMessage;

_defineProperty(IllustratedMessage, "propTypes", {
  /** The heading to be displayed */
  heading: _propTypes["default"].string,

  /** The description to be displayed */
  description: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),

  /** The illustration to be rendered above heading. Should be an SVG element. */
  illustration: _propTypes["default"].element,

  /** The heading level for the heading element to preserve hierarchy of headings in web page for accessibility. */
  ariaLevel: _propTypes["default"].number
});

_defineProperty(IllustratedMessage, "defaultProps", {
  heading: null,
  description: null
});